// extracted by mini-css-extract-plugin
module.exports = {"pttop":"userDetailFooter_pttop_1HFyl","footer":"userDetailFooter_footer_2fSQS","left":"userDetailFooter_left_3zM1T","right":"userDetailFooter_right_1uoAI"};